import * as React from 'react';
import Page from '../../components/Page';

export default function () {
    return <Page slug='home' />;
}
